export default [
  {
    name: "instagram",
    icon: "icon-instagram",
    link: "https://www.instagram.com/vocemagazine",
  },
  {
    name: "x",
    icon: "icon-xtwitter",
    link: "https://twitter.com/iVoCE",
  },
  {
    name: "youtube",
    icon: "icon-youtube",
    link: "https://www.youtube.com/user/VOCEchannel",
  },
  {
    name: "tiktok",
    icon: "icon-tiktok",
    link: "https://www.tiktok.com/@voce_magazine"
  },
  {
    name: "facebook",
    icon: "icon-facebook",
    link: "https://ja-jp.facebook.com/vocejapan",
  },
  {
    name: "pinterest",
    icon: "icon-pinterest",
    link: "https://www.pinterest.jp/vocemagazine",
  },
];
